<!-- =========================================================================================
    File Name: TableSingleSelected.vue
    Description: Add functionality on selecting row
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <div>
  <vx-card>
      <div class="p-6">
        <div class="vx-col w-full">
          <div class="mb-4 flex flex-wrap justify-between">
            <div class="flex w-2/3 h-12">
              <vs-input class="mr-4" v-model="serverParams.keyword" placeholder="학원명" @keyup.enter="onSearch"/>
              <vs-button color="primary" type="border" icon-pack="feather" icon="icon-search" @click="onSearch"></vs-button>
            </div>
            <div class="flex w-1/3 justify-end">
              <vs-button class="" @click="onAdd">학원추가</vs-button>
            </div>
          </div>
        </div>
        <vue-good-table
          mode="remote"
          isLoading.sync="isLoading"
          @on-page-change="onPageChange"
          @on-per-page-change="onPerPageChange"
          @on-sort-change="onSortChange"
          @on-row-click="onRowClick"
          :pagination-options="{
            enabled: true,
            dropdownAllowAll: false,
            nextLabel: '',
            prevLabel: '',
            rowsPerPageLabel: '',
            perPage: 20
          }"
          :sort-options="{
            enabled: true,
            //initialSortBy: {field: 'instituteName', type: 'asc'}
          }"
          :columns="columns"
          :rows="rows"
          :totalRows="totalRecords"
          :fix-header="true"
          :line-numbers="false"
          styleClass="vgt-table condensed"
          />
      </div>
    </vx-card> 
  </div>
</template>

<script>
//import Prism from 'vue-prism-component'
import { VueGoodTable } from 'vue-good-table'
import { fetchData } from '@/api/module'

export default {
  components: {
    VueGoodTable
  },
  data () {
    return {
      isLoading: false,
      institute_data : null,
      columns: [
        {
          label: '학원코드',
          field: 'instituteSeq',
          type: 'name'
        },
        {
          label: '학원명',
          field: 'instituteName',
          type: 'name'
        },
        {
          label: '수강생수',
          field: 'studentCnt',
          type: 'name',
          tdClass: 'text-right'
        },
        {
          label: '최대수강생수',
          field: 'licenseCnt',
          type: 'name',
          tdClass: 'text-center'
        },
        {
          label: '학원장명',
          field: 'presidentName',
          type: 'name'
        },
        {
          label: '전화번호',
          field: 'telephone',
          type: 'name',
          sortable: false
        },
        {
          label: '이동전화번호',
          field: 'mobilephone',
          type: 'name',
          sortable: false
        },
        {
          label: '가맹 계약일',
          field: 'frContractDate',
          type: 'date',
          dateInputFormat: 'yyyy-MM-dd',
          dateOutputFormat: 'yyyy-MM-dd'
        },
        {
          label: '만료일',
          field: 'frEndDate',
          type: 'date',
          dateInputFormat: 'yyyy-MM-dd',
          dateOutputFormat: 'yyyy-MM-dd'
        }
      ],
      rows: [],
      totalRecords: 0,
      serverParams: {
        page: 1,
        perPage: 20,
        field: 'instituteName',
        type: 'ASC',
        keyword: ''
      }
    }
  },
  
  methods: {
    updateParams () {
      const newObj = Object.assign({}, this.serverParams)
      this.$store.dispatch('setInstituteParams', newObj)
    },

    onAdd () {
      this.$router.push('/institute/institute-add')
    },

    onRowClick (params) {
      const instituteSeq = params.row.instituteSeq
      this.$router.push(`/institute/institute-view/${instituteSeq}`)
    },

    onPageChange (params) {
      this.serverParams.page = params.currentPage
      this.loadItems()
    },

    onPerPageChange (params) {
      this.serverParams.perPage = params.currentPerPage
      this.serverParams.page = 1
      this.loadItems()
    },

    onSortChange (params) {
      this.serverParams.field = params[0].field
      this.serverParams.type = params[0].type
      this.loadItems()
    },

    onSearch () {
      this.serverParams.page = 1
      this.loadItems()
    },

    async loadItems () { 
      try {
        this.updateParams()
        const { data } = await fetchData('institute', this.serverParams)
        this.$vs.loading.close()
        this.totalRecords = data.count
        this.rows = data.list
      } catch (error) {
        this.$vs.notify({
          title: 'Error',
          text: error.response.data.msg,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        }) 
      }
    }
  },
  created () {
    const params = this.$store.getters.getInstituteParams
    this.serverParams = Object.assign({}, params)
    this.loadItems()
  }
}
</script>
